import { WdsIconNameEnum } from '@worksome/wds-components'
import { ApprovalTrigger } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { Workflow } from '@/components/Workflows/Pages/Workflow/workflow'
import NodeTrigger from '@/components/Workflows/Pages/Editor/Nodes/NodeTrigger/NodeTrigger'
import { useFragment } from '@/gql'
import {
  ApprovalRuleFragment,
  WorkflowVariableRuleFragment,
} from '@/components/Workflows/Pages/Workflow/graphql/queries'
import NodeConditionRule from '@/components/Workflows/Pages/Editor/Nodes/NodeConditionRule/NodeConditionRule'
import NodeApprovals from '@/components/Workflows/Pages/Editor/Nodes/NodeApprovals/NodeApprovals'
import { deepClone } from '@/utils/tools'

export const triggerOptions = [
  {
    icon: WdsIconNameEnum.DOCUMENT_UNKNOWN,
    value: ApprovalTrigger.HireCreated,
    label: $t('Hire Created Approval'),
  },
  {
    icon: WdsIconNameEnum.DOCUMENT_UNKNOWN,
    value: ApprovalTrigger.HireChanged,
    label: $t('Hire Changed Approval'),
  },
  {
    icon: WdsIconNameEnum.DOCUMENT_SECURITY,
    value: ApprovalTrigger.ClassificationCreated,
    label: $t('Classification Created Approval'),
  },
]

export const mapWorkflowToNodeTree = (workflow: Workflow, root: NodeTrigger) => {
  if (workflow.approvalRules.length > 0) {
    for (const n of workflow.approvalRules) {
      const node = useFragment(ApprovalRuleFragment, n)
      const rules = node.rules
        .map((rule) => useFragment(WorkflowVariableRuleFragment, rule))
        .filter((r) => r !== undefined)

      if (rules.length > 0) {
        const ruleNode = new NodeConditionRule(root, rules, {
          key: node.id,
          children: [],
        })

        ruleNode.addChild(new NodeApprovals(ruleNode, deepClone(node.approvers)))

        root.addChild(ruleNode)
      } else {
        root.addChild(new NodeApprovals(root, deepClone(node.approvers)))
      }
    }
  } else {
    root.addChild(new NodeApprovals(root, []))
  }
}
